// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalFullScreen_container__bRxUI","heading":"ModalFullScreen_heading__s2dto","close":"ModalFullScreen_close__TQWlW","content":"ModalFullScreen_content__4770T"};